<div class="content-wrapper">
  <div class="container-fluid">
    <div class="content-header">
      <div class="ds-center">
        <div class="ds-icon-wrapper">
          <div class="ds-interrogation-icon">?</div>
        </div>
        <h1 class="ds-title">Não foi possível encontrar a rota "{{lastRouteName}}"</h1>
        <button type="button" class="btn btn-primary mt-4" (click)="goToHome()">Voltar para a página principal</button>
      </div>
    </div>
  </div>
</div>